import { render, staticRenderFns } from "./FormHeaderV1Properties.vue?vue&type=template&id=1f306e6d&"
import script from "./FormHeaderV1Properties.vue?vue&type=script&lang=js&"
export * from "./FormHeaderV1Properties.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../Breeze.Portal.Frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports